/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './PromotionsSidebar.css';
import fetch from '../../core/fetch';
import { Link } from 'react-router';

let boundItemClick = [];

@withStyles(s)
export default class PromotionsSidebar extends Component{
    

    constructor(props) {
        super(props);

        this.state = {
            promotions: []
        };

    }


    componentDidMount(){
        this.GetPromotions();
        
    }

    onItemClick(item, e) {  
        console.log(item.slug);
    }

    async GetPromotions() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{promotions{id, slug, title, content, banniere}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.promotions) throw new Error('Erreur sur le chargement des promotions !');

        this.setState({ promotions: data.promotions })
        
    }




    render(){
        
        return (
            <div className={s.root}>
                <div className={`promotions`}>
                    <div className={`content`}>
                        <span className={`titreSectionSidebar`}>Promotions</span>
                        <ul>
                        {this.state.promotions.map((item, index) => (
                            <li key={index} className={`promotion`} onClick={this.onItemClick.bind(this, item)}>
                                <a href="#"><img src={item.banniere} className={`banniere`} /></a>
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./components/PromotionsSidebar/PromotionsSidebar.js